module.exports = __webpack_public_path__ + "static/media/release-info2.322ef9f4.png";